import React, { ReactNode } from 'react';

// 图标库接口
export interface IconLibrary {
  name: string;
  displayName: string;
  icons: IconDefinition[];
}

// 图标定义接口
export interface IconDefinition {
  name: string;
  displayName: string;
  component?: ReactNode;
  svgPath?: string;
}

// 图标库注册表
const iconLibraries = new Map<string, IconLibrary>();

// 内置图标库：字母图标（默认）
const letterIconLibrary: IconLibrary = {
  name: 'letter',
  displayName: '字母',
  icons: [],
};

iconLibraries.set('letter', letterIconLibrary);

export function registerIconLibrary(library: IconLibrary): void {
  iconLibraries.set(library.name, library);
}

export function getIconLibrary(name: string): IconLibrary | undefined {
  return iconLibraries.get(name);
}

export function getAllIconLibraries(): IconLibrary[] {
  return Array.from(iconLibraries.values());
}

export function getIconsFromLibrary(libraryName: string): IconDefinition[] {
  const library = getIconLibrary(libraryName);
  return library?.icons || [];
}

export function searchIcons(libraryName: string, query: string): IconDefinition[] {
  const icons = getIconsFromLibrary(libraryName);
  if (!query.trim()) return icons;
  
  const lowerQuery = query.toLowerCase();
  return icons.filter(icon => 
    icon.name.toLowerCase().includes(lowerQuery) ||
    icon.displayName.toLowerCase().includes(lowerQuery)
  );
}

export function generateLetterIcon(name: string): string {
  return name.charAt(0).toUpperCase();
}

export function renderIcon(
  libraryName: string,
  iconName: string,
  className?: string
): ReactNode {
  const library = getIconLibrary(libraryName);
  if (!library) return null;
  
  const icon = library.icons.find(i => i.name === iconName);
  if (!icon) return null;
  
  if (icon.component) {
    return React.cloneElement(icon.component as React.ReactElement, { className });
  }
  
  if (icon.svgPath) {
    return React.createElement('svg', {
      className,
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
    }, React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 2,
      d: icon.svgPath,
    }));
  }
  
  return null;
}
